import { computed, ComputedRef } from 'vue';
import { useUserStore } from '@/store/user';

export default function useCurrentUser(): ComputedRef<string> {
  const userStore = useUserStore();
  return computed(() => userStore.currentUser?.email || '');
}
